/* eslint-disable */
import stickAnchor from '../modules/stickAnchor';
import trigger from '../modules/trigger';
import stickSidebarMulti from '../modules/stickSidebarMulti';
import Slider from "../modules/slider"
import Breakpoint from '../modules/breakpoint'

function InfiniteStep(list) {
    const slides = list.querySelectorAll(".slide");
    const items = list.querySelectorAll(".item");

    let inc = 0;
    let disable = true;

    if (items.length <= 4) return;

    const clone = slides[0].cloneNode(true);

    list.appendChild(clone);

    list.classList.add("infinite");

    const step = () => {
        if (disable) return
        setTimeout(() => {
            if (disable) return
            inc++;
            list.style.setProperty("--step", inc);
            if (inc == Math.ceil(items.length / 4)) {
                inc = 0;
                list.addEventListener("transitionend", () => {
                    list.classList.add("reset");
                    list.style.setProperty("--step", inc);
                    step()
                }, { once: true })
            } else {
                list.classList.remove("reset");
                list.addEventListener("transitionend", () => step(), { once: true })
            }
        }, 4000)
    }

    this.enable = () => {
        disable = false;
        step();
    }

    this.disable = () => {
        disable = true;
    }
}

export default el => {
    // nav anchor
    // const visu = el.querySelector(".wrapper-sidebar");
    const visu = el.querySelector(".wrapper-sidebar");
    const anchorsticky = el.querySelector(".anchor-sticky");
    stickAnchor(visu, anchorsticky)

    // activation des liens en fonction des sections
    const sections = document.querySelectorAll('main,section[id]');
    const links = el.querySelectorAll('.anchor a, .anchor-sticky a');
    trigger(sections, links);

    // sidebar sticky avec changement de couleur
    stickSidebarMulti();

    //  slider en mobile / slider pas 4 en desktop
    const slider = el.querySelector(".avocats .slider");
    const list_avocats = el.querySelector(".avocats .list-avocats");
    if (slider) {
        const myslider = new Slider(slider);

        const infiniteStep = new InfiniteStep(list_avocats);

        const breakpoint = new Breakpoint(1280);
        breakpoint.under = () => {
            myslider.enable();
            infiniteStep.disable();
        }
        breakpoint.above = () => {
            myslider.disable();
            infiniteStep.enable();
        }
    }
};

